/**
 * Given a form control name, this function will try to return a corresponding
 * value used for the autocomplete attribute.
 *
 * @see https://webaim.org/techniques/forms/controls#attributes
 * @see https://www.w3.org/TR/WCAG21/#input-purposes
 */

const inputControlPurposes = [
  "name",
  "honorific-prefix",
  "given-name",
  "additional-name",
  "family-name",
  "honorific-suffix",
  "nickname",
  "organization-title",
  "username",
  "new-password",
  "current-password",
  "organization",
  "street-address",
  "address-line1",
  "address-line2",
  "address-line3",
  "address-level4",
  "address-level3",
  "address-level2",
  "address-level1",
  "country",
  "country-name",
  "postal-code",
  "cc-name",
  "cc-given-name",
  "cc-additional-name",
  "cc-family-name",
  "cc-number",
  "cc-exp",
  "cc-exp-month",
  "cc-exp-year",
  "cc-csc",
  "cc-type",
  "transaction-currency",
  "transaction-amount",
  "language",
  "bday",
  "bday-day",
  "bday-month",
  "bday-year",
  "sex",
  "url",
  "photo",
  "tel",
  "tel-country-code",
  "tel-national",
  "tel-area-code",
  "tel-local",
  "tel-local-prefix",
  "tel-local-suffix",
  "tel-extension",
  "email",
  "impp",
];

const aliases = {
  name_first: "given-name",
  name_last: "family-name",
};

export default function getAutocomplete(name) {
  if (aliases[name]) {
    return aliases[name];
  }

  if (inputControlPurposes.indexOf(name) > -1) {
    return name;
  }

  return;
}
